module.exports = __webpack_public_path__ + "img/Sccirocco.cf3d384f.jpg";